exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loadingDots-e3782{display:inline;font-size:0}.loadingDots-e3782 span{animation:animate-3aadd 1.4s infinite ease-in-out both;background-color:#656a70;border-radius:100%;display:inline-block;height:1.2rem;margin:0 .2rem;transform:scale(0.7);width:1.2rem}.loadingDots-e3782.light-8acea span{background-color:#fff}.loadingDots-e3782 span:first-of-type{animation-delay:-0.32s}.loadingDots-e3782 span:nth-of-type(2){animation-delay:-0.16s}@keyframes animate-3aadd{0%,80%,100%{transform:scale(0.6)}40%{transform:scale(1)}}", ""]);

// Exports
exports.locals = {
	"loadingDots": "loadingDots-e3782",
	"animate": "animate-3aadd",
	"light": "light-8acea"
};